import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { URLService } from '../services/dynamic-url.service'; // Adjust the path as per your project
import { Tier, Capability } from '../models/tier';

interface TiersAndCapabilities {
  tiers: Tier[];
  capabilities: Capability[];
}

@Injectable({
  providedIn: 'root',
})
export class TierService {
  private readonly FREE_TIER = 'Free Tier';

  public tiers$: Observable<Tier[]>;
  public capabilities$: Observable<Capability[]>;
  private tiersAndCapabilities$: Observable<TiersAndCapabilities>;

  constructor(private readonly http: HttpClient, private readonly urlService: URLService) {
    this.tiersAndCapabilities$ = this.getAllTiersAndCapabilities();
    this.tiers$ = this.tiersAndCapabilities$.pipe(map((res) => res.tiers));
    this.capabilities$ = this.tiersAndCapabilities$.pipe(map((res) => res.capabilities));
  }

  // Fetch all tiers
  private getAllTiersAndCapabilities(): Observable<TiersAndCapabilities> {
    return this.http
      .get<TiersAndCapabilities>(`${this.urlService.getDynamicUrl()}/tiers/`)
      .pipe(shareReplay(1));
  }

  // Checks if an institution is on the free tier
  isInstitutionOnFreeTier(institutionTierId?: string): Observable<boolean> {
    return this.tiers$.pipe(
      map((tiers) => {
        if (!institutionTierId) {
          return false;
        }
        const currentTier = tiers.find((tier) => tier._id === institutionTierId);
        return currentTier?.name === this.FREE_TIER;
      }),
    );
  }
}
